/*
LUCID LOOM — STEP 38
EINBAUORT IN SHOPIFY:
Onlineshop → Themes → … → Code bearbeiten → Assets → ll-cart-drawer-motion.js

WAS TUN:
Neue JS-Datei namens ll-cart-drawer-motion.js anlegen.
Falls sie bereits existiert: den KOMPLETTEN Inhalt ersetzen.

ENTHÄLT:
Cart-Drawer Open/Close / Scroll-Lock / Backdrop / Motion-Logik.
*/
(function() {
  if (window.__LLCartDrawerCleanFinalMotionV1) return;
  window.__LLCartDrawerCleanFinalMotionV1 = true;

  let lockedScrollY = 0;
  let scrollLocked = false;
  let previousHtmlScrollBehavior = '';
  let listenersActive = false;
  let closeTimer = null;
  let isClosing = false;
  let drawerTrigger = null;
  let pendingDrawerTrigger = null;
  let pendingDrawerTriggerAt = 0;

  const OPEN_MS = 740;
  const CLOSE_MS = 960;

  const scrollKeys = [
    ' ',
    'PageUp',
    'PageDown',
    'End',
    'Home',
    'ArrowUp',
    'ArrowDown'
  ];

  function getScrollY() {
    return (
      window.scrollY ||
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }

  function setScrollY(y) {
    const targetY = Math.max(0, Number(y || 0));

    if (Math.abs(getScrollY() - targetY) <= 1) {
      return;
    }

    window.scrollTo(0, targetY);
    document.documentElement.scrollTop = targetY;
    document.body.scrollTop = targetY;
  }

  function getDialog() {
    return document.querySelector('cart-drawer-component dialog');
  }

  function rememberDrawerTrigger(target) {
    const element = target && target.nodeType === 1 ? target : target && target.parentElement;
    if (!element || typeof element.closest !== 'function') return;

    const control = element.closest(
      'button, a[href], input, select, textarea, [role="button"], [tabindex]:not([tabindex="-1"])'
    );

    if (!control || control.closest('cart-drawer-component')) return;

    pendingDrawerTrigger = control;
    pendingDrawerTriggerAt = Date.now();
  }

  function getDrawerInner() {
    return document.querySelector('cart-drawer-component .cart-drawer__inner');
  }

  function getPanel() {
    return (
      document.querySelector('cart-drawer-component .cart-drawer__inner') ||
      document.querySelector('cart-drawer-component .cart-drawer__dialog') ||
      getDialog()
    );
  }

  function isDrawerOpen() {
    const dialog = getDialog();
    return !!(dialog && dialog.hasAttribute('open'));
  }

  function clearBadLocks() {
    const html = document.documentElement;
    const body = document.body;

    html.classList.remove(
      'overflow-hidden',
      'scroll-locked',
      'no-scroll',
      'lock-scroll',
      'cart-drawer-open',
      'drawer-open'
    );

    body.classList.remove(
      'overflow-hidden',
      'scroll-locked',
      'no-scroll',
      'lock-scroll',
      'cart-drawer-open',
      'drawer-open'
    );

    [html, body].forEach((el) => {
      if (!el || !el.style) return;

      el.style.position = '';
      el.style.top = '';
      el.style.left = '';
      el.style.right = '';
      el.style.width = '';
      el.style.height = '';
      el.style.overflow = '';
      el.style.overflowX = '';
      el.style.overflowY = '';
      el.style.touchAction = '';
    });
  }

  function keepScrollWhileOpen() {
    if (!scrollLocked || !isDrawerOpen()) return;

    const currentY = getScrollY();

    if (Math.abs(currentY - lockedScrollY) > 1) {
      setScrollY(lockedScrollY);
    }
  }

  function preventOutsideScroll(event) {
    if (!scrollLocked || !isDrawerOpen()) return;

    const panel = getPanel();

    if (panel && panel.contains(event.target)) {
      return;
    }

    event.preventDefault();
    setScrollY(lockedScrollY);
  }

  function preventOutsideKeyScroll(event) {
    if (!scrollLocked || !isDrawerOpen()) return;
    if (!scrollKeys.includes(event.key)) return;

    const panel = getPanel();

    if (panel && panel.contains(document.activeElement)) {
      return;
    }

    event.preventDefault();
    setScrollY(lockedScrollY);
  }

  function addListeners() {
    if (listenersActive) return;

    document.addEventListener('wheel', preventOutsideScroll, {
      passive: false,
      capture: true
    });

    document.addEventListener('touchmove', preventOutsideScroll, {
      passive: false,
      capture: true
    });

    document.addEventListener('keydown', preventOutsideKeyScroll, true);
    window.addEventListener('scroll', keepScrollWhileOpen, {
      passive: true
    });

    listenersActive = true;
  }

  function removeListeners() {
    if (!listenersActive) return;

    document.removeEventListener('wheel', preventOutsideScroll, true);
    document.removeEventListener('touchmove', preventOutsideScroll, true);
    document.removeEventListener('keydown', preventOutsideKeyScroll, true);
    window.removeEventListener('scroll', keepScrollWhileOpen);

    listenersActive = false;
  }

  function enableBackdrop() {
    document.documentElement.classList.remove('ll-cart-drawer-backdrop-closing');
    document.documentElement.classList.add('ll-cart-drawer-blur-ready', 'll-cart-drawer-backdrop-active');

    if (document.body) {
      document.body.classList.remove('ll-cart-drawer-backdrop-closing');
      document.body.classList.add('ll-cart-drawer-backdrop-active');
    }
  }

  function disableBackdrop() {
    document.documentElement.classList.remove('ll-cart-drawer-blur-ready');

    if (!isClosing) {
      document.documentElement.classList.remove('ll-cart-drawer-backdrop-active');

      if (document.body) {
        document.body.classList.remove('ll-cart-drawer-backdrop-active');
      }
    }
  }

  function removeBackdropAfterClose() {
    document.documentElement.classList.remove(
      'll-cart-drawer-blur-ready',
      'll-cart-drawer-backdrop-active',
      'll-cart-drawer-backdrop-closing'
    );

    if (document.body) {
      document.body.classList.remove(
        'll-cart-drawer-backdrop-active',
        'll-cart-drawer-backdrop-closing'
      );
    }
  }

  function startBackdropClose() {
    document.documentElement.classList.remove('ll-cart-drawer-blur-ready');
    document.documentElement.classList.add('ll-cart-drawer-backdrop-closing');

    if (document.body) {
      document.body.classList.add('ll-cart-drawer-backdrop-closing');
    }
  }

  function lockScroll(forceY) {
    const nextY = typeof forceY === 'number' ? forceY : getScrollY();

    lockedScrollY = nextY;

    if (!scrollLocked) {
      previousHtmlScrollBehavior = document.documentElement.style.scrollBehavior || '';
      document.documentElement.style.scrollBehavior = 'auto';
      clearBadLocks();
      scrollLocked = true;
    }

    document.documentElement.classList.add('ll-cart-drawer-soft-open');
    document.body.classList.add('ll-cart-drawer-soft-open');

    addListeners();
  }

  function unlockScroll() {
    if (!scrollLocked) return;

    const restoreY = lockedScrollY;

    scrollLocked = false;
    removeListeners();

    document.documentElement.classList.remove('ll-cart-drawer-soft-open');
    document.body.classList.remove('ll-cart-drawer-soft-open');

    clearBadLocks();
    setScrollY(restoreY);

    requestAnimationFrame(() => {
      clearBadLocks();
      setScrollY(restoreY);
      document.documentElement.style.scrollBehavior = previousHtmlScrollBehavior;
    });
  }

  // Free shipping: one source of truth, synchronized with Ajax cart updates.
  // Values are always minor units (cents for EUR); never parse formatted prices.
  let shippingFrame = 0;
  let shippingTarget = null;
  let shippingPreviouslyOpen = false;
  let shippingCurrent = null;
  let shippingRevision = 0;
  let shippingOpenTimer = null;

  function cancelShippingAnimation() {
    if (shippingFrame) cancelAnimationFrame(shippingFrame);
    shippingFrame = 0;
    shippingTarget = null;
  }

  function shippingElements() {
    const root = document.querySelector('cart-drawer-component .lucid-freeship');
    if (!root) return null;
    const threshold = Math.round(Number(root.dataset.llShipThreshold));
    if (!Number.isFinite(threshold) || threshold <= 0) return null;
    return {
      root,
      threshold,
      fill: root.querySelector('.lucid-freeship__fill'),
      bar: root.querySelector('.lucid-freeship__bar'),
      text: root.querySelector('.lucid-freeship__text'),
      title: root.querySelector('.lucid-freeship__title'),
      locale: root.dataset.llShipLocale || 'de-DE'
    };
  }

  function shippingFormat(cents, locale) {
    let formatter;
    try {
      formatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (_) {
      formatter = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return formatter.format(Math.max(0, Math.round(cents)) / 100) + ' €';
  }

  function shippingSetVisual(els, remaining, progress) {
    if (!els.root.isConnected) return;
    const clampedProgress = Math.min(100, Math.max(0, progress));
    if (els.fill) {
      els.fill.style.setProperty('transition', 'none', 'important');
      els.fill.style.width = clampedProgress + '%';
    }
    if (els.bar) els.bar.setAttribute('aria-valuenow', String(Math.round(clampedProgress)));
    const figure = els.root.querySelector('.lucid-freeship__remaining strong');
    if (figure) figure.textContent = shippingFormat(remaining, els.locale);
    shippingCurrent = { remaining, progress: clampedProgress };
  }

  function shippingEnsureState(els, remaining) {
    if (!els.text) return;
    const done = remaining <= 0;
    const zone = els.root.querySelector('.lucid-freeship__zone');
    const threshold = els.root.querySelector('.lucid-freeship__threshold');
    if (zone) zone.hidden = done;
    if (threshold) threshold.hidden = done;
    const currentDone = !els.text.querySelector('.lucid-freeship__remaining');
    if (done !== currentDone) {
      els.text.replaceChildren();
      if (!done) {
        const label = document.createElement('span');
        label.className = 'lucid-freeship__remaining';
        label.appendChild(document.createElement('strong'));
        label.appendChild(document.createTextNode(' bis GRATIS VERSAND'));
        els.text.appendChild(label);
      }
    }
    if (els.title) {
      const headline = els.title.querySelector('span');
      if (headline) headline.textContent = done ? 'GRATIS VERSAND' : 'VERSAND';
      const price = els.title.querySelector('.lucid-freeship__price');
      if (price) price.remove();
    }
  }

  function animateShippingProgress(mode, rawTotal) {
    const els = shippingElements();
    if (!els || !isDrawerOpen() || isClosing) return;
    const total = Math.max(0, Math.round(Number(rawTotal ?? els.root.dataset.llShipTotal)));
    if (!Number.isFinite(total)) return;
    const remaining = Math.max(0, els.threshold - total);
    const progress = Math.min(100, total / els.threshold * 100);
    const opening = mode === 'open';
    // The amount shown must always match the latest confirmed cart state.
    els.root.dataset.llShipTotal = String(total);
    const source = opening ? { remaining: els.threshold, progress: 0 } :
      (shippingCurrent || {
        remaining: Math.max(0, els.threshold - Math.max(0, Math.round(Number(els.root.dataset.llShipTotal)))),
        progress
      });
    cancelShippingAnimation();
    // During a move across the threshold keep a numeric amount while animating.
    if (remaining > 0 && !els.root.querySelector('.lucid-freeship__remaining')) shippingEnsureState(els, 1);
    if (opening && remaining === 0) {
      // The success state has no number, but the bar still animates from zero.
      shippingEnsureState(els, 0);
    }
    shippingSetVisual(els, source.remaining, source.progress);
    const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reduced ? 0 : (opening ? 1200 : 700);
    let started = null;
    const state = { root: els.root };
    shippingTarget = state;
    const ease = t => 1 - Math.pow(1 - t, 3);
    function tick(now) {
      if (shippingTarget !== state || !isDrawerOpen() || isClosing || !els.root.isConnected) return;
      if (started === null) started = now;
      const p = ease(duration ? Math.min(1, (now - started) / duration) : 1);
      const currentRemaining = Math.round(source.remaining + (remaining - source.remaining) * p);
      const currentProgress = source.progress + (progress - source.progress) * p;
      shippingSetVisual(els, currentRemaining, currentProgress);
      if (p < 1) {
        shippingFrame = requestAnimationFrame(tick);
      } else {
        shippingEnsureState(els, remaining);
        shippingSetVisual(els, remaining, progress);
        shippingTarget = null;
        shippingFrame = 0;
      }
    }
    shippingFrame = requestAnimationFrame(tick);
  }

  function shippingTotalFromCart(cart) {
    if (!cart || typeof cart !== 'object') return null;
    // Match the Liquid sum of final_line_price, not an undiscounted subtotal.
    if (Array.isArray(cart.items)) {
      return cart.items.reduce((sum, item) => sum + Math.round(Number(item.final_line_price) || 0), 0);
    }
    return Number.isFinite(Number(cart.total_price)) ? Math.round(Number(cart.total_price)) : null;
  }

  function shippingCartChanged(cart) {
    if (!isDrawerOpen() || isClosing) return;
    const total = shippingTotalFromCart(cart);
    if (total === null) return;
    shippingRevision += 1; // Invalidate older /cart.js reads.
    const els = shippingElements();
    if (!els) return;
    // If the new section has not yet rendered, update its data and animation now.
    animateShippingProgress('update', total);
  }

  async function shippingReadCurrentCart() {
    if (!isDrawerOpen() || isClosing) return;
    const revision = ++shippingRevision;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision !== shippingRevision || !isDrawerOpen() || isClosing) return;
      const total = shippingTotalFromCart(cart);
      if (total === null) return;
      const els = shippingElements();
      if (!els) return;
      els.root.dataset.llShipTotal = String(total);
      if (shippingPreviouslyOpen) animateShippingProgress('update', total);
    } catch (_) { /* Preserve valid server-rendered values when offline. */ }
  }

  document.addEventListener('cart:change', e => shippingCartChanged(e.detail?.cart));
  document.addEventListener('cart:refresh', e => shippingCartChanged(e.detail?.cart));
  document.addEventListener('cart-drawer:refresh', e => shippingCartChanged(e.detail?.cart));
  document.addEventListener('cart-drawer:rendered', e => {
    // Re-rendering replaces the DOM: apply the last confirmed total to the new node.
    if (!isDrawerOpen() || isClosing) return;
    const els = shippingElements();
    if (!els) return;
    const total = shippingTotalFromCart(e.detail?.cart);
    if (total !== null) {
      shippingCartChanged(e.detail.cart);
    } else {
      shippingReadCurrentCart();
    }
  });

  function openDrawer() {
    const dialog = getDialog();
    if (!dialog) return;

    const activeElement = document.activeElement;
    const hasRecentTrigger = pendingDrawerTrigger &&
      pendingDrawerTrigger.isConnected &&
      Date.now() - pendingDrawerTriggerAt < 5000;

    if (hasRecentTrigger) {
      drawerTrigger = pendingDrawerTrigger;
    } else if (activeElement && activeElement !== document.body && !dialog.contains(activeElement)) {
      drawerTrigger = activeElement;
    }

    pendingDrawerTrigger = null;
    pendingDrawerTriggerAt = 0;

    clearTimeout(closeTimer);
    closeTimer = null;
    isClosing = false;

    const restoreY = getScrollY();

    lockedScrollY = restoreY;

    removeBackdropAfterClose();
    lockScroll(restoreY);
    enableBackdrop();

    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    dialog.classList.remove(
      'll-is-closing',
      'll-is-open',
      'll-open-active',
      'll-motion-live',
      'll-motion-prep',
      'll-first-paint-hidden',
      'll-is-opening'
    );

    dialog.classList.add('ll-first-paint-hidden', 'll-motion-prep', 'll-is-opening');

    if (!dialog.open) {
      dialog.setAttribute('aria-modal', 'false');
      try {
        if (typeof dialog.show === 'function') {
          dialog.show();
        } else {
          dialog.setAttribute('open', '');
        }
      } catch (error) {
        dialog.setAttribute('open', '');
      }
    }

    try {
      dialog.focus({
        preventScroll: true
      });
    } catch (error) {
      try {
        dialog.focus();
      } catch (innerError) {}
    }

    if (
      document.activeElement &&
      dialog.contains(document.activeElement) &&
      document.activeElement !== dialog &&
      typeof document.activeElement.blur === 'function'
    ) {
      document.activeElement.blur();
    }

    // The shipping animation must wait until the drawer has completed its entrance.
    shippingPreviouslyOpen = false;
    shippingCurrent = null;
    cancelShippingAnimation();
    clearTimeout(shippingOpenTimer);
    shippingReadCurrentCart();

    const inner = getDrawerInner();

    void dialog.offsetWidth;
    if (inner) void inner.offsetWidth;

    requestAnimationFrame(() => {
      if (!dialog.open || isClosing) return;

      dialog.classList.remove('ll-first-paint-hidden');
      dialog.classList.remove('ll-motion-prep');
      dialog.classList.add('ll-motion-live');

      if (inner) void inner.offsetWidth;

      requestAnimationFrame(() => {
        if (!dialog.open || isClosing) return;

        dialog.classList.add('ll-open-active');
        enableBackdrop();

        // Begin the shipping animation 500 ms before the entrance finishes.
        shippingOpenTimer = window.setTimeout(() => {
          if (!dialog.open || isClosing) return;
          shippingPreviouslyOpen = true;
          animateShippingProgress('open');
        }, Math.max(0, OPEN_MS + 40 - 500));

        window.setTimeout(() => {
          if (!dialog.open || isClosing) return;

          dialog.classList.remove(
            'll-is-opening',
            'll-motion-live',
            'll-motion-prep',
            'll-first-paint-hidden'
          );

          dialog.classList.add('ll-is-open');
          shippingPreviouslyOpen = true;
        }, OPEN_MS + 40);
      });
    });
  }

  function finishClose(dialog, restoreY) {
    clearTimeout(closeTimer);
    closeTimer = null;

    if (dialog) {
      try {
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      } catch (error) {
        dialog.removeAttribute('open');
      }

      dialog.classList.remove(
        'll-is-closing',
        'll-is-opening',
        'll-is-open',
        'll-open-active',
        'll-motion-live',
        'll-motion-prep',
        'll-first-paint-hidden'
      );
    }

    isClosing = false;
    lockedScrollY = restoreY;

    unlockScroll();
    removeBackdropAfterClose();

    const triggerToRestore = drawerTrigger;
    drawerTrigger = null;
    if (triggerToRestore && triggerToRestore.isConnected && typeof triggerToRestore.focus === 'function') {
      requestAnimationFrame(() => {
        try {
          triggerToRestore.focus({ preventScroll: true });
        } catch (error) {
          triggerToRestore.focus();
        }
      });
    }
  }

  function closeDrawer() {
    cancelShippingAnimation();
    shippingPreviouslyOpen = false;
    const dialog = getDialog();
    const restoreY = scrollLocked ? lockedScrollY : getScrollY();

    lockedScrollY = restoreY;

    if (!dialog || !dialog.open) {
      finishClose(dialog, restoreY);
      return;
    }

    if (isClosing) return;

    isClosing = true;
    clearTimeout(shippingOpenTimer);
    cancelShippingAnimation();
    startBackdropClose();

    if (document.activeElement && typeof document.activeElement.blur === 'function') {
      document.activeElement.blur();
    }

    dialog.classList.remove(
      'll-is-opening',
      'll-is-open',
      'll-open-active',
      'll-motion-live',
      'll-motion-prep'
    );

    dialog.classList.add('ll-is-closing');

    closeTimer = setTimeout(() => {
      finishClose(dialog, restoreY);
    }, CLOSE_MS);
  }

  const observer = new MutationObserver(() => {
    if (isDrawerOpen()) {
      const dialog = getDialog();
      if (!shippingPreviouslyOpen && !isClosing && dialog && dialog.classList.contains('ll-is-open')) {
        shippingPreviouslyOpen = true;
        animateShippingProgress('open');
      }
      if (!isClosing && !scrollLocked) {
        lockScroll(getScrollY());
        enableBackdrop();
      }
    } else if (!isClosing && scrollLocked) {
      shippingPreviouslyOpen = false;
      clearTimeout(shippingOpenTimer);
      cancelShippingAnimation();
      shippingCurrent = null;
      unlockScroll();
      removeBackdropAfterClose();
    }
  });

  const observedDialog = getDialog();

  if (observedDialog) {
    observer.observe(observedDialog, {
      attributes: true,
      attributeFilter: ['open', 'class']
    });
  }

  document.addEventListener('pointerdown', function(event) {
    rememberDrawerTrigger(event.target);
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    rememberDrawerTrigger(document.activeElement);
  }, true);

  document.addEventListener('click', function(event) {
    if (!event.isTrusted) return;
    rememberDrawerTrigger(event.target);
  }, true);

  document.addEventListener('pointerdown', function(event) {
    if (!isDrawerOpen() || isClosing) return;

    const drawerInner = getDrawerInner();

    if (drawerInner && drawerInner.contains(event.target)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    closeDrawer();
  }, true);

  document.addEventListener('click', function(event) {
    const overlay = event.target.closest && event.target.closest('cart-drawer-component .cart-overlay');
    const closeButton = event.target.closest && event.target.closest('cart-drawer-component [data-ll-cart-close]');

    if (!overlay && !closeButton) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    closeDrawer();
  }, true);

  document.addEventListener('keydown', function(event) {
    if (event.key !== 'Escape') return;
    if (!isDrawerOpen() || isClosing) return;

    event.preventDefault();
    event.stopPropagation();

    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    closeDrawer();
  }, true);

  document.addEventListener('cancel', function(event) {
    if (
      event.target &&
      event.target.matches &&
      event.target.matches('cart-drawer-component dialog')
    ) {
      event.preventDefault();
      closeDrawer();
    }
  }, true);

  document.addEventListener('close', function(event) {
    if (
      event.target &&
      event.target.matches &&
      event.target.matches('cart-drawer-component dialog')
    ) {
      event.target.classList.remove(
        'll-is-closing',
        'll-is-opening',
        'll-is-open',
        'll-open-active',
        'll-motion-live',
        'll-motion-prep',
        'll-first-paint-hidden'
      );

      isClosing = false;
      shippingPreviouslyOpen = false;
      clearTimeout(shippingOpenTimer);
      cancelShippingAnimation();
      shippingCurrent = null;
      unlockScroll();
      removeBackdropAfterClose();
    }
  }, true);

  window.addEventListener('pageshow', function() {
    clearBadLocks();

    if (!isDrawerOpen()) {
      removeListeners();
      scrollLocked = false;
      isClosing = false;
      clearTimeout(closeTimer);
      closeTimer = null;

      document.documentElement.classList.remove('ll-cart-drawer-soft-open');
      document.body.classList.remove('ll-cart-drawer-soft-open');

      removeBackdropAfterClose();
    }
  });

  window.LLCartDrawerLock = {
    open: openDrawer,
    close: closeDrawer,
    lock: lockScroll,
    unlock: unlockScroll,
    isOpen: isDrawerOpen
  };

  if (isDrawerOpen()) {
    lockScroll(getScrollY());
    enableBackdrop();
  } else {
    clearBadLocks();
    removeListeners();
    removeBackdropAfterClose();
    scrollLocked = false;
    isClosing = false;
  }
})();
